<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:20px; margin-bottom:0vh; justify-content: center !important; color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md style="padding-top: 0vh;">
        <v-layout wrap style="padding-top: 0vh;">
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;">
            <v-container grid-list-md style="padding-top: 0vh;">
              <v-layout wrap>
                <!--  -->
                <v-flex sm12 md12 lg12 xl12>
                  <!-- <v-icon @click="backlink()">navigate_before</v-icon> -->
                  <v-btn icon flat @click="backlink()"><v-icon>navigate_before</v-icon></v-btn>
                  <h3 class="header">ข้อมูลบอท {{botid}}</h3>
                </v-flex>
                <v-flex sm12 md12 lg12 xl12>
                  <div class="Setting">
                    <div class="SettingBlock">
                      <ul class="List_Register">
                        <li class="List_item">
                          <div class="List_item_header">
                            <p class="SettingTtl">รูปบอท</p>
                          </div>
                          <div class="List_item_body">
                            <div class="SettingImg">
                              <div class="SettingImgWrap">
                                <div>
                                  <img :src="(profilepicture == '')? '../../../static/img/robot/robot1.png':profilepicture" class="alligator-turtle" style=" cursor: pointer; width: 145px;height: 145px;" @click="Showdialog()">
                                  <label for="SettingImg" class="SettingImgBtn" @click="Showdialog()">
                                    อัปโหลด
                                  </label>
                                </div>
                              </div>
                            </div>
                            <p class="EditAreaNote">รองรับไฟล์ .JPEG/.PNG/.GIF</p>
                            <p class="EditAreaNote"></p>
                            <p class="EditAreaNote"></p>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <DialogBotImage :dialogBoteditimage="dialogBoteditimage" :BotDetail="BotDetail" @closeDialogBotEdit="closeDialogBotEdit" @editSuccess="editSuccess" />
                    <!---->
                    <div class="SettingBlock">
                      <p class="SettingTtl">ID บอท</p>
                      <div>
                        <div class="EditArea">
                          <div class="EditAreaCont BreakWord">{{ botid }}</div>
                        </div>
                      </div>
                    </div>
                    <!---->
                    <div class="SettingBlock">
                      <p class="SettingTtl">ชื่อบอท</p>
                      <div>
                        <div class="EditArea" v-if="!editname">
                          <div class="EditAreaCont BreakWord" v-if="name !== ''">{{ name }}</div>
                          <div class="EditAreaCont BreakWord" v-else>-</div>
                          <v-btn flat small class="buttonedit" @click="editname = !editname">
                            <span>แก้ไข</span>
                          </v-btn>
                        </div>
                        <div class="EditArea" v-else>
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <input type="text" placeholder="กรุณากรอกชื่อของบอท" class="InputEdit" v-model="nameedit" v-if="nameedit == ''">
                              <input type="text" :placeholder="name" class="InputEdit" v-model="nameedit" v-else>
                            </div>
                            <p class="EditAreaNote" style="color:red;" v-if="nameedit == ''">{{ alerterror }}</p>
                          </div>
                          <v-btn flat small class="buttonedit" @click="updatename()">
                            <span>อัปเดต</span>
                          </v-btn>
                          <v-btn flat small class="buttonedit" @click="cancelname()">
                            <span>ยกเลิก</span>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <!---->
                    <!---->
                    <div class="SettingBlock">
                      <p class="SettingTtl">รหัสผ่าน</p>
                      <div>
                        <div class="EditArea" v-if="!editpassword">
                          <div class="EditAreaCont BreakWord" v-if="password !== ''">{{ password }}</div>
                          <div class="EditAreaCont BreakWord" v-else>-</div>
                          <v-btn flat small class="buttonedit" @click="editpassword = !editpassword">
                            <span>แก้ไข</span>
                          </v-btn>
                        </div>
                        <div class="EditArea" v-else>
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <input type="text" placeholder="กรุณากรอกรหัสผ่าน" class="InputEdit" v-model="passwordedit" v-if="passwordedit == ''">
                              <!-- <input type="text" :placeholder="password" class="InputEdit" v-model="passwordedit" v-else> -->
                              <v-text-field :label="password" counter :rules="passwordRules" v-model="passwordedit" solo maxlength="6" v-else></v-text-field>
                            </div>
                            <p class="EditAreaNote" style="color:red;" v-if="passwordedit == ''">{{ alerterror }}</p>
                          </div>
                          <v-btn flat small class="buttonedit" @click="updatepassword()">
                            <span>อัปเดต</span>
                          </v-btn>
                          <v-btn flat small class="buttonedit" @click="cancelpassword()">
                            <span>ยกเลิก</span>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <!---->
                    <div class="SettingBlock">
                      <p class="SettingTtl">สถานะ</p>
                      <div>
                        <div class="EditArea" v-if="!editdescription">
                          <div class="EditAreaCont BreakWord" v-if="status != ''">{{ status }}</div>
                          <div class="EditAreaCont BreakWord" v-else>-</div>
                          <v-btn flat small class="buttonedit" @click="editdescription = !editdescription">
                            <span>แก้ไข</span>
                          </v-btn>
                        </div>
                        <div class="EditArea" v-else>
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <!---->
                              <input type="text" placeholder="สถานะของบอท" class="InputEdit" v-model="statusedit">
                            </div>
                          </div>
                          <v-btn flat small class="buttonedit" @click="updatestatus()">
                            <span>อัปเดต</span>
                          </v-btn>
                          <v-btn flat small class="buttonedit" @click="cancelstatus()">
                            <span>ยกเลิก</span>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div class="SettingBlock">
                      <p class="SettingTtl">ข้อความหลังจากเพิ่มเพื่อน</p>
                      <div>
                        <div class="EditArea" v-if="!editmsgdefault">
                          <div class="EditAreaCont BreakWord" v-if="msgdefault != ''">{{ msgdefault}}</div>
                          <div class="EditAreaCont BreakWord" v-else>-</div>
                          <v-btn flat small class="buttonedit" @click="editmsgdefault = !editmsgdefault">
                            <span>แก้ไข</span>
                          </v-btn>
                        </div>
                        <div class="EditArea" v-else>
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <!---->
                              <input type="text" placeholder="ข้อความหลังจากเพิ่มเพื่อน" class="InputEdit" v-model="msgdefaultedit" v-if="msgdefaultedit == ''">
                              <input type="text" :placeholder="msgdefault" class="InputEdit" v-model="msgdefaultedit" v-else>
                            </div>
                          </div>
                          <v-btn flat small class="buttonedit" @click="updatemsgdefault()">
                            <span>อัปเดต</span>
                          </v-btn>
                          <v-btn flat small class="buttonedit" @click="cancelmsgdefault()">
                            <span>ยกเลิก</span>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <!-- -------------------------------------- -->
                <v-flex sm12 md12 lg12 xl12>
                  <h3 class="header">ข้อมูลสำหรับ API</h3>
                </v-flex>
                <v-flex sm12 md12 lg12 xl12>
                  <div class="Setting">
                    <div class="SettingBlock">
                      <p class="SettingTtl">bot_id</p>
                      <div>
                        <div class="EditArea">
                          <div class="EditAreaCont BreakWord">{{ tokenbot }} <v-icon style="color:#0000008a; font-size: 13px !important; cursor: pointer; " v-clipboard:copy="tokenbot">file_copy</v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!---->
                    <div class="SettingBlock">
                      <p class="SettingTtl">Webhook</p>
                      <div>
                        <div class="EditArea" v-if="!editwebhook">
                          <div class="EditAreaCont BreakWord" v-if="webhook != ''">{{webhook}}</div>
                          <div class="EditAreaCont BreakWord" v-else>-</div>
                          <v-btn flat small class="buttonedit" @click="editwebhook = !editwebhook">
                            <span>แก้ไข</span>
                          </v-btn>
                        </div>
                        <div class="EditArea" v-else>
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <!---->
                              <input type="text" placeholder="กรุณากรอกwebhook(ถ้ามี)" class="InputEdit" v-model="webhookedit">
                            </div>
                          </div>
                          <v-btn flat small class="buttonedit" @click="updatewebhook()">
                            <span>อัปเดต</span>
                          </v-btn>
                          <v-btn flat small class="buttonedit" @click="cancelwebhook()">
                            <span>ยกเลิก</span>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <!-- -------------------------------------- -->
                <v-flex sm12 md12 lg12 xl12>
                  <h3 class="header">QR code สำหรับเพิ่มเพื่อน</h3>
                </v-flex>
                <v-flex sm12 md12 lg12 xl12>
                  <div class="Setting">
                    <div class="SettingBlock">
                      <div class="SettingQr">
                        <p class="SettingTtl">QR code</p>
                        <p class="SettingQrImg">
                          <qrcode :value="tokenuserQR" style="margin-left: 10vw; width: 20vh;" id="downloadqr"></qrcode>
                          <qrcode :value="tokenuserQR" style="display: none;" :options="{ size: 500 }" id="downloadqr-forload"></qrcode>
                        </p>
                        <p class="SettingQrNote">
                          คุณสามารถใช้ QR code นี้ส่งมอบให้บุคคลอื่น เพิ่มคุณเป็นเพื่อนได้
                          <a href="#" class="button" id="btn-download" :download="'bot_' + name + '.png'" @click="loadqr()">Download</a>
                          <br>
                        </p>
                      </div>
                      <!-- -------------------------------------- -->
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <br>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import DialogBotImage from '@/components/dialogCropBot'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  components: {
    DialogBotImage
  },
  data: () => ({
    dialogBoteditimage: false,
    alerterror: '',
    development: '',
    webhook: '',
    msgdefault: '',
    token: '',
    tokenbot: '',
    name: '',
    status: '',
    webbackend: '',
    tokenedit: '',
    developmentedit: '',
    nameedit: '',
    statusedit: '',
    webhookedit: '',
    msgdefaultedit: '',
    edit: false,
    editname: false,
    editdescription: false,
    editwebhook: false,
    editmsgdefault: false,
    tokenservice: '',
    tokenuserQR: '',
    hideAuthen: false,
    profilepicture: '',
    windowWidth: '',
    password: '',
    editpassword: false,
    passwordedit: '',
    BotDetail: {},
    passwordRules: [
      v => (!!v && v.length <= 6) || 'กรุณากรอกตัวเลขอย่างน้อย 6 ตัว',
      v => /^([0-9])+$/.test(v) || 'กรุณากรอกเป็นตัวเลข 0-9 เท่านั้น',
      v => /[^\W_]+$/.test(v) || 'ไม่สามารถกรอกตัวอักษรหรืออักขระพิเศษได้'
    ]
  }),
  methods: {
    Showdialog () {
      this.dialogBoteditimage = true
    },
    closeDialogBotEdit (value) {
      this.dialogBoteditimage = value
    },
    editSuccess (value) {
      this.profilepicture = value
      this.BotDetail.profilepicture = value
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqr-forload')
      var button = document.getElementById('btn-download')
      // var img2 = this.resizeImage(cnvs, 500, 500)
      var canvas = document.createElement('canvas');
      canvas.width = 250;
      canvas.height = 250;
      canvas.getContext('2d').drawImage(cnvs, 0, 0, 250, 250);

      var dataURL = canvas.toDataURL('image/png')
      button.href = dataURL
    },
    resizeImage(img, w, h) {
      var result = new Image();
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      result.src = canvas.toDataURL();
      return result;
    },
    backlink () {
      this.$router.push('/develop/homepage/' + this.botid + '/' + this.tokenbot)
    },
    cancelname () {
      this.editname = !this.editname
      this.nameedit = this.name
    },
    cancelpassword () {
      this.editpassword = !this.editpassword
      this.passwordedit = this.password
    },
    cancelstatus () {
      this.editdescription = !this.editdescription
      this.statusedit = this.status
    },
    cancelwebhook () {
      this.editwebhook = !this.editwebhook
      this.webhookedit = this.webhook
    },
    cancelmsgdefault () {
      this.editmsgdefault = !this.editmsgdefault
      this.msgdefaultedit = this.msgdefault
    },
    updatewebhook () {
      this.editwebhook = !this.editwebhook
      this.$http.post(process.env.APImanage + '/setwebhook', {token_bot: this.tokenbot, webhook: this.webhookedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.webhook = this.webhookedit
          this.botinfo.webhook = this.webhookedit
          this.$store.dispatch('changeBot', this.botinfo)
        }
      }, (response) => {})
    },
    updatemsgdefault () {
      this.editmsgdefault = !this.editmsgdefault
      this.$http.post(process.env.APImanage + '/setmessagedefault', {token_bot: this.tokenbot, message_default: this.msgdefaultedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.msgdefault = this.msgdefaultedit
          this.botinfo.message_default = this.msgdefaultedit
          this.$store.dispatch('changeBot', this.botinfo)
          // console.log(this.msgdefault)
        }
      }, (response) => {})
    },
    updatename () {
      this.editname = !this.editname
      if (this.nameedit !== '') {
        this.$http.post(process.env.APImanage + '/setnameuser', {tokenuser: this.tokenbot, name: this.nameedit}).then((response) => {
          // console.log(response)
          if (response.body['status'] === 'success') {
            this.name = this.nameedit
            this.alerterror = ''
            this.botinfo.nickname = this.nameedit
            this.$store.dispatch('changeBot', this.botinfo)
            // console.log(this.botinfo.nickname)
          }
        }, (response) => {})
      } else {
        // alert('กรุณากรอกชื่อ')
        this.nameedit = ''
        this.alerterror = 'กรุณากรอกชื่อของบอท'
        this.editname = !this.editname
      }
    },
    updatepassword () {
      this.editpassword = !this.editpassword
      // if (this.passwordedit !== '') {
      this.$http.post(process.env.APImanage + '/set_password_bot', {tokenBot: this.tokenbot, password_new: this.passwordedit}).then((response) => {
        // console.log(response)
        if (response.body['status'] === 'success') {
          this.password = this.passwordedit
          this.alerterror = ''
          this.botinfo.password = this.passwordedit
          this.$store.dispatch('changeBot', this.botinfo)
        }
      }, (response) => {})
    },
    updatestatus () {
      this.editdescription = !this.editdescription
      this.$http.post(process.env.APImanage + '/setstatususer', {tokenuser: this.tokenbot, status: this.statusedit}).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.status = this.statusedit
          this.$store.dispatch('listFriend', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          // console.log(this.statusedit)
        }
      }, (response) => {})
    },
    uppicbot () {
      document.getElementById('uploadpicprofilebot').click()
    },
    uppicbottest () {
      document.getElementById('uploadpicprofilebot').click()
    },
    previewImageprofilesbot (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', this.tokenbot)
      this.$http.post(process.env.APImanage + '/setpictureprofileuser', uploadFile).then((response) => {
        if (response.body['status'] === 'success') {
          this.$swal(
            'รูปประจำตัวบอท',
            'เปลี่ยนรูปประจำตัวบอทสำเร็จ.',
            'success'
          )
          this.profilepicture = response.body.filename
          this.$store.dispatch('changeBot', response.body.filename)
        }
      }, (response) => {})
    }
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile',
      botinfo: 'botinfo'
    })
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/dev_editbot/' + this.botid)
      }
    },
    myprofile () {
      console.log('myProfile')
      // this.filename = localStorage.getItem('profilepicture')
    },
    botinfo () {
      if (this.botinfo === 'noneselect') {
        // this.room = 'noneselect'
      } else {
        this.botid = this.$route.params.id
        this.tokenbot = this.$route.params.tokenbot
        this.$http.post(process.env.APImanage + '/getbot', { tokenuser: this.token, bot_id: this.botid }).then((response) => {
          // console.log(response.body.data_bot[0])
          if (response.body['status'] === 'success') {
            var item = response.body.data_bot[0]
            this.BotDetail = item
            this.tokenbot = item.tokenuser
            this.webhook = item.webhook
            this.msgdefault = item.message_default
            this.name = item.nickname
            this.profilepicture = item.profilepicture
            this.status = item.status
            this.statusedit = this.status
            this.webhookedit = this.webhook
            this.msgdefaultedit = this.msgdefault
            this.nameedit = this.name
            this.tokenservice = localStorage.getItem('tokenservice')
            this.password = item.password
            this.passwordedit = this.password
            this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.tokenbot)
          }
        }, (response) => {})
      }
    }
  },
  created () {
    this.token = localStorage.getItem('tokenuser')
    this.botid = this.$route.params.id
    this.tokenbot = this.$route.params.tokenbot
    this.$http.post(process.env.APImanage + '/getbot', { tokenuser: this.token, bot_id: this.botid }).then((response) => {
      if (response.body['status'] === 'success') {
        var item = response.body.data_bot[0]
        this.BotDetail = item
        this.tokenbot = item.tokenuser
        this.webhook = item.webhook
        this.msgdefault = item.message_default
        this.name = item.nickname
        this.profilepicture = item.profilepicture
        this.status = item.status
        this.statusedit = this.status
        this.webhookedit = this.webhook
        this.msgdefaultedit = this.msgdefault
        this.nameedit = this.name
        this.tokenservice = localStorage.getItem('tokenservice')
        this.password = item.password
        this.passwordedit = this.password
        this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.tokenbot)
      }
    }, (response) => {})
    this.webbackend = process.env.API
  }
}
</script>
<style type="text/css" scoped>
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
  border-style: solid;
  border-width: thin;
  border-radius: 5px;
  border-color: #d2d8dd;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 43px !important;
  padding: 0 !important;
}


.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.edit {
  font-weight: 100;
}

.inputWrapper {
  height: 32px;
  width: 90px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*margin-top: 5vh;*/
  /*Using a background color, but you can use a background image to represent a button*/
  /*background-color: #DDF;*/
}

.img {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}

.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}

.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}

input[type=textprofile] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 10px 10px 10px 10px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

input[type=textprofile]:disabled {
  background: #cac9c9;
}

.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}

.urlcopymessageapi {
  display: none !important;
}

.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}

.header {
  display: block;
  font-size: 1.17em;
  -webkit-margin-before: 1em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  color: black !important;
}

.header::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: 0;
  height: 32px;
  border-left: 4px solid #1a76d2;
}

.Setting {
  margin-bottom: 2vh;
}

.SettingBlock {
  padding: 30px 20px;
  border-top: 1px solid #DEE5EC;
}

.SettingBlock> :last-child {
  margin-bottom: 0;
}

.List_Register {
  margin-bottom: 32px;
  box-sizing: border-box;
}

.List_Register .List_item:last-child {
  border-bottom: none;
}

.List_Register .List_item {
  display: -webkit-flex;
  display: flex;
  padding: 0;
}

.List_Register .List_item:last-child .List_item_header {
  width: 200px;
}

.SettingTtl {
  margin-bottom: 8px;
  font-weight: bold;
  white-space: nowrap;
  color: black !important;
}

.md91SettingImg {
  padding-bottom: 12px;
  line-height: 1;
}

.SettingImgWrap {
  display: inline-block;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.SettingImgMask {
  position: relative;
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 40px;
}

.SettingImgBtn {
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: -20px;
  right: -20px;
  line-height: 1;
  width: 40px;
  height: 30px;
  bottom: 0;
  left: 0;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: -20px;
  right: -20px;
  line-height: 1;
  width: 40px;
  height: 50%;
  bottom: 0;
  left: 0;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, .75);
}

.SettingImgInput {
  position: absolute;
  left: -9999px;
}

.EditAreaNote {
  margin: 8px 0 0;
  font-size: 13px;
  color: #BEC8D2;
  font-size: 12px;
}

.EditArea {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}

.BreakWord {
  white-space: pre-wrap;
  word-break: break-all;
  word-break: break-word;
  word-wrap: break-word;
}

.EditAreaCont {
  width: 100%;
  padding-right: 1em;
  box-sizing: border-box;
}

.SettingQr {
  display: -webkit-flex;
  display: flex;
}

.SettingQrImg {
  margin: 0 50px;
  position: relative;
}

.SettingQrNote {
  margin-bottom: 0;
  font-size: 13px;
}

.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}

.EditAreaContFlex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}

.InputEdit {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d2d8dd;
  border-radius: 4px;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.BGwhite {
  background-color: white !important;
}

/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/

</style>



// WEBPACK FOOTER //
// src/components/managebot/detailbot.vue